(function () {
  'use strict';

  var TEXTO = "Comprar ahora";
  if (!TEXTO || TEXTO.indexOf('translation missing') === 0) return;var SELECTOR = 'a#more-payment-options-link, a.shopify-payment-button__more-options';
  var CORTE_MS = 20000;

  function pon(el) {if (el.children.length > 0) return false;
    var actual = el.textContent.trim();
    if (actual === '' || actual === TEXTO) return false;
    el.textContent = TEXTO;
    return true;
  }

  function aplica(raiz) {
    var n = 0;
    var nodos = raiz.querySelectorAll(SELECTOR);for (var i = 0; nodos.length > i; i++) {
      if (pon(nodos[i])) n++;
    }
    return n;
  }

  function vigila(raiz) {
    aplica(raiz);
    if (!window.MutationObserver) return;
    var obs = new MutationObserver(function () { aplica(raiz); });obs.observe(raiz, { childList: true, subtree: true, characterData: true });
    setTimeout(function () { obs.disconnect(); }, CORTE_MS);
  }

  function arranca() {
    var formularios = document.querySelectorAll('.product-form');
    for (var i = 0; formularios.length > i; i++) vigila(formularios[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }document.addEventListener('on:variant:change', function (e) {
    var raiz = (e.target && e.target.closest) ? e.target.closest('.product-form') : null;
    vigila(raiz || document);
  });
})();
